import React, { Component } from 'react';
import _ from 'lodash';

import TimeoutSignsParkinglocationsModel from './TimeoutSignsParkinglocationsModel';

import { Select } from 'antd';
const Option = Select.Option;

class TimeoutSignsParkinglocationsSelect extends Component {

  state = {
    children: []
  }

  componentWillMount() {
    TimeoutSignsParkinglocationsModel.getAll()
      .then(data => {
        data = _.sortBy(data, ['parkingLocationName']);
        var children = [];
        data.map((child, key) => {
          return children.push(<Option key={child.parkingLocationID}>{child.parkingLocationName}</Option>);
        });
        this.setState({
          children: children
        });
      });
  }

  render() {
    return (
      <Select
        size="default"
        showSearch
        placeholder={this.props.placeholder ? this.props.placeholder : 'Zvolte lokalitu'}
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        onChange={(value) => { this.props.onChange(value) }}
        {...this.props}>
        {this.state.children}
      </Select>
    );
  }
}

export default TimeoutSignsParkinglocationsSelect;


// WEBPACK FOOTER //
// ./src/components/TimeoutSignsParkinglocationsSelect.js